// Tabs
export const TABS = {
    PRODUCTS: 'products',
    FILES: 'files',
};

const ENV_VALUES = {
    PROD: 'prod',
    UAT: 'uat',
    SBX: 'sbx',
};

export const ENVIRONMENTS = [
    { label: 'Production', value: ENV_VALUES.PROD },
    { label: 'UAT', value: ENV_VALUES.UAT },
    { label: 'SBX', value: ENV_VALUES.SBX },
];

const DEPLOYMENT_ENV = process.env.VITE_SENTRY_ENV_NAME;

// Prod targets all environments, uat targets uat, sbx/dev target sbx
export const getAvailableEnvironments = () =>
    DEPLOYMENT_ENV === ENV_VALUES.PROD
        ? ENVIRONMENTS
        : ENVIRONMENTS.filter(e => e.value === (DEPLOYMENT_ENV || ENV_VALUES.SBX));

export const DEFAULT_ENVIRONMENT = DEPLOYMENT_ENV || ENV_VALUES.SBX;

// API Endpoints
export const API_ENDPOINTS = {
    PRODUCTS: '/Products',
    FILES: '/Files',
    FILE_DOWNLOAD: '/FileDownload',
    FILE_UPLOAD: '/Files/UploadURL',
    UPDATE_RATES: '/Rates/UpdateRates',
    CANCEL_SCHEDULED_UPDATE: '/Rates/CancelUpdate',
};

// Sort Options
export const SORT_OPTIONS = [
    { label: 'Name A-Z', value: 'NAME_ASC' },
    { label: 'Name Z-A', value: 'NAME_DESC' },
    { label: 'Newest First', value: 'NEWEST' },
    { label: 'Oldest First', value: 'OLDEST' },
];

// Pagination
export const PAGINATION = {
    DEFAULT_PAGE: 1,
    ROWS_PER_PAGE: 10,
    ROWS_PER_PAGE_OPTIONS: [10, 25, 50],
};

// Rider Names for Filter
export const RIDER_NAMES = [
    { label: 'WP', value: 'WP' },
    { label: 'CHILDWP', value: 'CHILDWP' },
    { label: 'WR', value: 'WR' },
    { label: 'ADB', value: 'ADB' },
    { label: 'ATR', value: 'ATR' },
];

export const DEFAULT_PRODUCT_FILTERS = {
    productType: '',
    riders: '',
    scheduled: false,
};

export const UPDATE_STATUS = {
    SCHEDULED: 'Scheduled',
    QUEUED: 'Queued',
    PROCESSING: 'Processing',
    COMPLETED: 'Completed',
    FAILED: 'Failed',
    CANCELED: 'Canceled',
};
 
export const getMinTime = () => {
    const now = new Date();
    return new Date(now.getTime() + 5 * 60 * 1000); // +5 minutes
};

export const isToday = (date) => {
    if (!date) return false;
    const today = new Date();
    return new Date(date).toDateString() === today.toDateString();
};